export const UI_SHOWS_CONST = {
  DASHBOARD: {
    SECTION: {
      FINANCES: 'finances',
      MANAGEMENT: 'management',
      MESSAGES: 'messages',
    },
  },
}
